import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { TimeFormatPipe } from '../../pipes/time-format/time-format';
import {TimeFormatFromNowPipe} from "../../pipes/time-format-from-now/time-format-from-now";

/*
  Generated class for the EchartsOptionProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EchartsOptionProvider {
  constructor(public http: Http) {
    console.log('Hello EchartsOptionProvider Provider');
  }

  hourList = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
  ];

  getMessageBar(data_array, _dark_limit = 0) {
    return {
      legend: {
        data: [
          {
            name: '消息数量',
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          },
        ],
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      xAxis: [
        {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          data: data_array
            .map((item, i) => {
              return new TimeFormatPipe().transform(
                new Date().getTime() - i * 24 * 60 * 60 * 1000,
                'MM-dd'
              );
            })
            .reverse(),
        },
      ],
      yAxis: [
        {
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          axisLabel: {
            color: '#000',
          },
          type : 'value',
          name: ':数量/条'
        }
      ],
      color: ['#8660A4'],
      series: [
        {
          name: '消息数量',
          type: 'bar',
          barCategoryGap: '40%',
          itemStyle: {
            //通常情况下：
            normal: {
              //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
              color: function(params) {
                var colorList = [
                  'rgba(134,96,164,0.6)',
                  'rgba(134,96,164,0.9)',
                ];
                return params.value >= _dark_limit && params.value > 0
                  ? colorList[1]
                  : colorList[0];
              },
              barBorderRadius: 80,
            },
          },
          markLine: {
            symbol: [, 'arrow'],
            symbolSize: 8,
            lineStyle: {
              normal: {
                color: '#926FAD',
              },
            },
            data: [
              {
                name: '',
                type: 'average',
              },
            ],
          },

          data: data_array,
        },
      ],
    };
  }

  getActiveRateLine(data_array) {
    return {
      legend: {
        data: [
          {
            name: '活跃率',
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          },
        ],
        height: 20,
      },
      tooltip: {
        trigger: 'axis',
        // axisPointer: {
        //   type: 'cross',
        //   label: {
        //     backgroundColor: '#6a7985'
        //   }
        // },
        formatter: '{b}<br>日活跃率:&nbsp;{c0}%',
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '3%',
        containLabel: true,
      },
      // color:['#24C5D3'],
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          data: data_array
            .map((item, i) => {
              return new TimeFormatPipe().transform(
                new Date().getTime() - i * 24 * 60 * 60 * 1000,
                'MM-dd'
              );
            })
            .reverse(),
        },
      ],
      yAxis: [
        {
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          axisLabel: {
            color: '#000',
          },
          type: 'value',
          name: '比例:%',
        },
      ],
      series: [
        {
          name: '活跃率',
          type: 'line',
          smooth: true,
          symbolSize: 5,
          data: data_array.map(item => (item * 100).toFixed(2)),
        },
      ],
    };
  }

  getChinaOption(data_array) {
    // console.log( Math.max.apply([],data_array));
    let max = 0;
    data_array.forEach(item => {
      if (max < item.value) {
        max = item.value;
      }
    });
    return {
      tooltip: {
        trigger: 'item',
      },
      grid: {
        left: '3%',
        right: '20px',
        bottom: '3%',
        top:'20px',
        containLabel: true
      },
      visualMap: {
        type: 'piecewise',
        min: 0,
        max: max,
        splitNumber: 4,
        text: ['高', '低'],
        inverse: true,
        orient: 'horizontal',
        realtime: false,
        calculable: true,
        // color: ['#24C5D3','#79D9E2','#AFEDF2 ','#D8D8D8']
      },
      series: [
        {
          name: '国内分布',
          type: 'map',
          mapType: 'china',
          top: 10,
          right: 10,
          width: '90%',
          height: '90%',
          tooltip: {
            formatter: params => {
              return (
                '地域分布<br>' +
                params.name +
                ':' +
                (params.value ? params.value : '0')
              );
            },
          },
          itemStyle: {
            normal: {
              borderColor: '#fff',
            },
            emphasis: {
              normal: {
                borderColor: '#fff',
              },
            },
          },
          label: {
            normal: {
              show: true,
              color: '#fff',
            },
            emphasis: {
              show: true,
            },
          },
          data:
            data_array.length > 0 ? data_array : [{ name: '北京', value: '1' }],
        },
      ],
    };
  }

  getGenderChange(male_array, female_array) {
    return {
      tooltip: {
        trigger: 'axis',
        // axisPointer: {
        //   type: 'cross',
        //   label: {
        //     backgroundColor: '#6a7985'
        //   }
        // },
        formatter:
          "{b}<div><i class='fa echarts-font fa-mars'></i>&nbsp;男:{c0}人</div><div><i class='fa echarts-font fa-venus'></i>&nbsp;女:{c1}人</div>",
      },
      legend: {
        data: [
          {
            name: '男',
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          },
          {
            name: '女',
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          },
        ],
        // height:20
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '3%',
        containLabel: true,
      },
      color: ['#95DDDE', '#FFC3C7'],
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: '#999',
          },
        },
        data: male_array
          .map((item, i) => {
            return new TimeFormatPipe().transform(
              new Date().getTime() - i * 24 * 60 * 60 * 1000,
              'MM-dd'
            );
          })
          .reverse(),
      },
      yAxis: {
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: '#999',
          },
        },
        type: 'value',
        name: '人数:人',
        // axisLabel: {
        //   formatter: '{value}'
        // }
        axisLabel: {
          color: '#000',
          // axisLabel: {
          formatter: '{value}',
          // }
        },
      },
      series: [
        {
          name: '男',
          type: 'line',
          smooth: true,
          data: male_array,
        },
        {
          name: '女',
          type: 'line',
          smooth: true,
          data: female_array,
        },
      ],
    };
  }

  getRelation(data_array, link_array) {
    return {
      animationDurationUpdate: 1500,
      animationEasingUpdate: 'quinticInOut',
      label: {
        normal: {
          show: true,
          textStyle: {
            fontSize: 12,
          },
        },
      },
      // legend: {
      //   x: "center",
      //   data: ["邀请"]
      // },
      series: [
        {
          type: 'graph',
          tooltip: {},
          ribbonType: true,
          layout: 'circular',
          focusNodeAdjacency: true,
          // animation:false,
          categories: [
            {
              name: '发过红包的成员',
              itemStyle: {
                normal: {
                  color: '#E7505A',
                },
              },
            },
            {
              name: '普通成员',
              itemStyle: {
                normal: {
                  color: '#8493A6',
                },
              },
            },
          ],
          label: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 12,
              },
              position: 'center',
              fontWeight: 'bold',
              formatter: '{b}',
              normal: {
                textStyle: {
                  fontFamily: '宋体',
                },
              },
            },
          },
          edgeLabel: {
            normal: {
              show: true,
              textStyle: {
                fontSize: 10,
              },
              formatter: '{c}',
            },
          },
          edgeSymbol: ['circle', 'arrow'],
          edgeSymbolSize: [4, 10],
          data: data_array,
          links: link_array.map(item => {
            item.value = '邀请';
            return item;
          }),
          lineStyle: {
            normal: {
              opacity: 0.9,
              width: 1,
              curveness: 0,
            },
          },
        },
      ],
    };
  }

  getPhoneRate(data_array) {
    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)',
      },
      legend: {
        x: 'center',
        bottom: '8%',
        height: 100,
        width: '80%',
        data: data_array.map(item => {
          return {
            name: item.name,
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          };
        }),
      },
      // color:['#24C5D3','#3B98D9','#F2784B','#F1C40F','#8290A3','#FF8C93'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['36%', '65%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '18',
                fontWeight: 'bold',
              },
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: data_array,
        },
      ],
    };
  }

  getInfluenceRate(data) {
    return {
      series: [
        {
          name: '影响力',
          type: 'gauge',
          z: 3,
          min: 0,
          max: 100,
          splitNumber: 10,
          radius: '80%',
          axisLine: {
            // 坐标轴线
            lineStyle: {
              // 属性lineStyle控制线条样式
              color: [[0.2, '#F1C40F'], [0.8, '#F2784B'], [1, '#E7505A']],
              width: 20,
            },
          },
          axisTick: {
            // 坐标轴小标记
            length: 25, // 属性length控制线长
            lineStyle: {
              // 属性lineStyle控制线条样式
              color: 'auto',
            },
          },
          splitLine: {
            // 分隔线
            length: 30, // 属性length控制线长
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: 'auto',
            },
          },
          axisLabel: {
            fontSize: 15,
          },
          title: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            fontWeight: 'bolder',
            fontSize: 20,
            fontStyle: 'italic',
          },
          detail: {
            // 其余属性默认使用全局文本样式，详见TEXTSTYL
            fontWeight: 'bolder',
            fontFamily: 'Arial',
            width: 100,
            fontStyle: 'italic',
          },
          data: [{ value: data, name: '影响力' }],
        },
      ],
    };
  }

  getRedPackageRate(red_package, total_num) {
    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)',
      },
      legend: {
        x: 'center',
        bottom: '8%',
        height: 100,
        width: '100%',
        data: [
          {
            name: '发红包数',
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          },
          {
            name: '其他人发红包数',
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          },
        ],
      },
      // color:['#E7505A','#24C5D3'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['36%', '65%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '18',
                fontWeight: 'bold',
              },
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: [
            { name: '发红包数', value: red_package },
            { name: '其他人发红包数', value: total_num - red_package },
          ],
        },
      ],
    };
  }

  getMsgRate(data_array) {
    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)',
      },
      legend: {
        x: 'center',
        bottom: '8%',
        height: 100,
        width: '80%',
        // textStyle:{
        //   rich:{
        //
        //   },
        //   width:'33.3%'
        // },
        data: data_array.map(item => {
          return {
            name: item.name,
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          };
        }),
      },
      // color:['#24C5D3','#3B98D9','#F2784B','#F1C40F','#8290A3','#FF8C93'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['36%', '65%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          // label: {
          //   normal: {
          //     show: false,
          //     position: 'center'
          //   },
          //   emphasis: {
          //     show: true,
          //     textStyle: {
          //       fontSize: '18',
          //       fontWeight: 'bold'
          //     }
          //   }
          // },
          // labelLine: {
          //   normal: {
          //     show: false
          //   }
          // },
          data: data_array,
        },
      ],
    };
  }

  getExceptionListOption(in_list = [], out_list = [], total_list = []) {
    return {
      legend: {
        data: [
          {
            name: '入群人数',
            // 强制设置图形为圆。
            icon: 'rect',
            // 设置文本为红色
          },
          {
            name: '退群人数',
            // 强制设置图形为圆。
            icon: 'rect',
            // 设置文本为红色
          },
          {
            name: '群人数',
            // 强制设置图形为圆。
            icon: 'circle',
            // 设置文本为红色
          },
        ],
        height: 20,
      },
      color: ['#F2784B', '#FFD87B', '#8660A4'],
      tooltip: {
        trigger: 'axis',
        // axisPointer: {
        //   type: 'cross',
        //   label: {
        //     backgroundColor: '#6a7985'
        //   }
        // },
        // formatter:"{b}<br>日活跃率:&nbsp;{c0}%"
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '3%',
        containLabel: true,
      },
      // color:['#24C5D3'],
      xAxis: [
        {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          data: in_list
            .map((item, i) => {
              return new TimeFormatPipe().transform(
                new Date().getTime() - i * 24 * 60 * 60 * 1000,
                'MM-dd'
              );
            })
            .reverse(),
        },
      ],
      yAxis: [
        {
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          axisLabel: {
            color: '#000',
          },
          type: 'value',
          name: '人数增减',
        },
        {
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          axisLabel: {
            color: '#000',
          },
          type: 'value',
          name: '群人数',
        },
      ],
      series: [
        {
          name: '入群人数',
          type: 'bar',
          stack: '人数增减',
          data: in_list,
        },
        {
          name: '退群人数',
          type: 'bar',
          stack: '人数增减',
          data: out_list.map(item => -item),
        },
        {
          name: '群人数',
          type: 'line',
          smooth: true,
          yAxisIndex: 1,
          symbolSize: 5,
          data: total_list,
        },
      ],
    };
  }

  getActiveLineOption(today_list = [], yes_list = []){
    let option = {
      legend: {
        data:[{
          name: '七日发言数',
          // 强制设置图形为圆。
          icon: 'circle',
          // 设置文本为红色
        }
        ],
        height: 20,
      },
      tooltip: {
        trigger: 'axis',
        // axisPointer: {
        //   type: 'cross',
        //   label: {
        //     backgroundColor: '#6a7985'
        //   }
        // },
        // formatter:"{b}<br>日活跃率:&nbsp;{c0}%"
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '3%',
        containLabel: true,
      },
      color: ['#5176CF', '#999999'],
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          data: this.hourList,
        },
      ],
      yAxis: [
        {
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#999',
            },
          },
          axisLabel: {
            color: '#000',
          },
          type : 'value',
          name:'数量/条'
        }
      ],
      series: [
        {

          name:'七日发言数',
          type:'line',
          smooth:true,
          symbolSize: 10,
          lineStyle: {
            normal: {
              color: '#5176CF',
              type: 'solid',
            },
          },
          markPoint: {},
          data: today_list,
        },
      ],
    };

    if (yes_list && yes_list.length) {
      option.legend.data.push({
        name: '昨日消息数',
        // 强制设置图形为圆。
        icon: 'circle',
        // 设置文本为红色
      });
      option.series.push({
        name: '昨日消息数',
        type: 'line',
        smooth: true,
        symbolSize: 5,
        markPoint: {},
        lineStyle: {
          normal: {
            color: '#99999',
            type: 'dashed',
          },
        },
        data: yes_list,
      });
    }
    option.series[0].markPoint = {
      data: [
        {
          type: '',
          coord: [today_list.length - 1, today_list[today_list.length - 1]],
          label: {
            normal: {
              show: true,
              formatter: '',
            },
          },
          itemStyle: {
            normal: {
              color: '#5176CF',
              borderColor: 'rgba(81,118,207,0.3)',
              borderWidth: 12, // 标注边线线宽，单位px，默认为1
            },
          },
          symbol: 'circle',
          symbolSize: 10,
        },
      ],
    };

    // formatter:"{b}<div><i class='fa echarts-font fa-mars'></i>&nbsp;男:{c0}人</div><div><i class='fa echarts-font fa-venus'></i>&nbsp;女:{c1}人</div>"
    return option;
  }

  getHomeLine(node_list = [],item_name = '群人数'){
    let time_list = [];
    let day_stamp = 24*60*60*1000;
    node_list.forEach((date,i) =>{
      time_list.unshift(new TimeFormatPipe().transform(Date.now() - day_stamp*(i +1 ),'MM-dd'));
    });
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          animation: false,
          label: {
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: 'rgba(255,255,255,0)',
            borderWidth: 0,
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            textStyle: {
              color: '#222'
            }
          }
        },
      },
      grid: {
        left: '3%',
        right: '20px',
        bottom: '3%',
        containLabel: true
      },

      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: time_list,
        splitNumber:node_list.length >7?6:1,
      },
      yAxis: [
        {
          type: 'value',
        }
      ],
      series: [
        {
          name:item_name,
          type:'line',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          data:node_list
        },
      ]
    }
  }


  getPeriodOption(nameIndex,avg_data,today_data){
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          animation: false,
          label: {
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: 'rgba(255,255,255,0)',
            borderWidth: 0,
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            textStyle: {
              color: '#222'
            }
          }
        },
      },
      legend:{
        data: nameIndex == 1?['平均活跃人数','今日活跃人数']:['平均发言数','今日发言数']
      },
      grid: {
        left: '3%',
        right: '20px',
        bottom: '3%',
        containLabel: true
      },

      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.hourList,
        splitNumber:2,
      },
      yAxis: [
        {
          type: 'value',
        }
      ],
      series: [
        {
          name:nameIndex == 1?'平均活跃人数':'平均发言数',
          type:'line',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          smooth:true,
          data:avg_data,
        },
        {
          name:nameIndex == 1?'今日活跃人数':'今日发言数',
          type:'line',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          smooth:true,
          lineStyle:{
            type:'dotted'
          },
          data:today_data
        },
      ]
    }
  }

  getTrendOption(name = '',data = []){
    let time_list = [];
    let day_stamp = 24*60*60*1000;
    data.forEach((date,i) =>{
      time_list.unshift(new TimeFormatPipe().transform(Date.now() - day_stamp*(i +1 ),'MM-dd'));
    });
    return  {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          animation: false,
          label: {
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: 'rgba(255,255,255,0)',
            borderWidth: 0,
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            textStyle: {
              color: '#222'
            }
          }
        },
      },
      legend:{
        data:[name]
      },
      grid: {
        left: '3%',
        right: '20px',
        bottom: '3%',
        containLabel: true
      },

      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: time_list,
      },
      yAxis: [
        {
          type: 'value',
        }
      ],
      series: [
        {
          name:name,
          type:'line',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          smooth:true,
          data:data
        }
      ]
    }
  }

  getContactTrendOption(name = '',data = [],hour_node = false){
    let time_list = [];
    if(hour_node){
      time_list = [...this.hourList]
    }
    else {
      let day_stamp = 24*60*60*1000;
      data.forEach((date,i) =>{
        time_list.unshift(new TimeFormatPipe().transform(Date.now() - day_stamp*(i +1 ),'MM-dd'));
      });
    }
    return  {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          animation: false,
          label: {
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: 'rgba(255,255,255,0)',
            borderWidth: 0,
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            textStyle: {
              color: '#222'
            }
          }
        },
      },
      legend:{
        data:[name]
      },
      grid: {
        left: '3%',
        right: '20px',
        bottom: '3%',
        containLabel: true
      },

      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: time_list,
      },
      yAxis: [
        {
          type: 'value',
        }
      ],
      series: [
        {
          name:name,
          type:'line',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          smooth:true,
          data:data
        }
      ]
    }
  }

  getActivityOption(activity_list,date_type){
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          animation: false,
          label: {
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: 'rgba(255,255,255,0)',
            borderWidth: 0,
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            textStyle: {
              color: '#222'
            }
          }
        },
      },
      legend:{
        data: [date_type == 1?'今日用户发言数':'用户平均发言数']
      },
      grid: {
        left: '3%',
        right: '20px',
        bottom: '3%',
        containLabel: true
      },

      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.hourList,
      },
      yAxis: [
        {
          type: 'value',
        }
      ],
      series: [
        {
          name:date_type == 1?'今日用户发言数':'用户平均发言数',
          type:'line',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          smooth:true,
          data:activity_list,
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/echarts-option/echarts-option.ts